import React, { useEffect, useState } from "react";
import MUITable from "Components/UI/Tables/MUITable";
import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import LinkIcon from "@mui/icons-material/Link";
import {
  getSystemStatusLabelById,
  getParseStatusLabelById,
} from "utils/labels";
import {
  getSystemStatusColorByLabel,
  getParseStatusColorByLabel,
} from "utils/colors";
import CommonChip from "Components/UI/Tables/CommonChip";
import { useEndCustomerPaymentBundles } from "Context/EndCustomerPaymentBundles";
import { CircularProgress } from "@mui/material";

const createTableRows = (bundles) => {
  return bundles.map((b) => {
    return [
      b.Id,
      b.PaymentAmount,
      b.PaymentDate,
      b.PaymentCount,
      b.PaymentAccount,
      b.FileId,
      b.FileName,
      b.ParseMessage,
      getParseStatusLabelById(b.ParseStatus),
      getSystemStatusLabelById(b.SystemStatus),
      b.CreateTime,
    ];
  });
};

export default function EndCustomerPaymentBundlesTable() {
  const {
    getPaymentBundles,
    paymentBundles,
    count,
    loading,
    setPaymentBundles,
  } = useEndCustomerPaymentBundles();

  const [rows, setRows] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(count);
  const [order, setOrder] = useState({ Column: "Id", Order: 1 });

  useEffect(() => {
    const asyncFetchPaymentBundles = async () => {
      const res = await getPaymentBundles({
        Order: order,
        Page: 0,
        PageSize: rowsPerPage,
      });
      if (res) {
        setTotalCount(res?.Count);
      }
    };

    asyncFetchPaymentBundles();
  }, []);

  useEffect(() => {
    getPaymentBundles({
      Order: order,
      Page: page,
      PageSize: rowsPerPage,
    });
  }, [rowsPerPage, page]);

  useEffect(() => {
    setPaymentBundles([]);
    setRows([]);
    getPaymentBundles({
      Order: order,
      Page: page,
      PageSize: rowsPerPage,
    });
    setPage(0);
  }, [order]);

  useEffect(() => {
    const rows = createTableRows(paymentBundles);
    setRows(rows);
  }, [paymentBundles]);

  const columns = [
    {
      name: "",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRenderLite: (dataIndex) => {
          return (
            <IconButton
              component={Link}
              to={`${rows[dataIndex][0]}`}
              aria-label="edit"
              size="small"
            >
              <LinkIcon sx={{ p: 0, m: 0 }} />
            </IconButton>
          );
        },
      },
    },
    {
      name: "Id",
      label: "ID",
      options: {
        filter: false,
      },
    },
    {
      name: "PaymentAmount",
      label: "Summa",
      options: {
        filter: false,
      },
    },
    {
      name: "PaymentDate",
      label: "Betalningsdatum",
      options: {
        filter: false,
      },
    },
    {
      name: "PaymentCount",
      label: "Antal",
      options: {
        filter: false,
      },
    },
    {
      name: "PaymentAccount",
      label: "Betalningskonto",
      options: {
        filter: false,
      },
    },
    {
      name: "FileId",
      label: "Fil ID",
      options: {
        filter: false,
      },
    },
    {
      name: "FileName",
      label: "Filnamn",
      options: {
        filter: false,
      },
    },
    {
      name: "ParseMessage",
      label: "Kontrollmeddelande",
      options: {
        filter: false,
      },
    },
    {
      name: "ParseStatus",
      label: "Kontrollstatus",
      options: {
        filter: false,
        customBodyRender: (value) => {
          return (
            <CommonChip
              labelName={value}
              color={getParseStatusColorByLabel(value)}
            />
          );
        },
      },
    },
    {
      name: "SystemStatus",
      label: "Status",
      options: {
        filter: false,
        customBodyRender: (value) => {
          return (
            <CommonChip
              labelName={value}
              color={getSystemStatusColorByLabel(value)}
            />
          );
        },
      },
    },
    {
      name: "Skapad",
      options: {
        filter: false,
      },
    },
  ];

  const options = {
    selectableRows: "none",
    selectableRowsHideCheckboxes: true,
    textLabels: {
      body: {
        noMatch: loading ? <CircularProgress /> : "",
      },
    },
    filterType: "dropdown",
    page: page,
    onChangePage: (currentPage) => setPage(currentPage),
    onChangeRowsPerPage: (numberOfRows) => setRowsPerPage(numberOfRows),
    onColumnSortChange: (changedColumn, direction) => {
      setOrder({ Column: changedColumn, Order: direction === "asc" ? 0 : 1 });
    },
    onChangeSort: (column, order) => {
      setOrder({ Column: column, Order: order });
    },
    pagination: true,
    rowsPerPage: rowsPerPage,
    count: totalCount,
    rowsPerPageOptions: [10, 30, 100],
    sortOrder: {
      name: order?.Column,
      direction: order?.Order === 0 ? "asc" : "desc",
    },
  };

  return (
    <MUITable options={options} title={""} data={rows} columns={columns} />
  );
}
